/*
    Create by you  2015-12-28
*/
"use strict";
angular.module("productManageMentAppsiteWatermarkMgrModule", [])
    .controller("productManageMentAppsitewatermarkMgrCtrl", ['$scope', 'productManageMentService', "$q", "trsHttpService", "$stateParams", '$modal', 'modalDialog', 'trsspliceString', '$timeout', 'newFileUpload', 'initSingleSelecet', 'initVersionService', 'initManageConSelectedService', 'productMangageMentWebsiteService', 'Upload', 'editingCenterService',
        function($scope, productManageMentService, $q, trsHttpService, $stateParams, $modal, modalDialog, trsspliceString, $timeout, newFileUpload, initSingleSelecet, initVersionService, initManageConSelectedService, productMangageMentWebsiteService, Upload, editingCenterService) {
            initStatus();
            initData();
            /**
             * [getChnlRights description]获取权限
             * @return {[type]} [description] null
             */
            function getWatermarkRights() {
                productMangageMentWebsiteService.getRight($stateParams.site, "", "appsetsite.mark").then(function(data) {
                    $scope.status.right = data;
                    $scope.status.new = data.mark.save;
                    $scope.status.del = data.mark.delete;
                    $scope.status.modify = data.mark.startorstop;
                });
            }
            /**
             * [selectAll description]全选
             * @return {[type]} [description] null
             */
            $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : []
                    .concat($scope.data.items);
            };
            /**
             * [selectDoc description]单选
             * @return {[type]} [description] null
             */
            $scope.selectDoc = function(item) {
                var index = $scope.data.selectedArray.indexOf(item);
                if (index < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice(index, 1);
                }
            };
            /**
             * [pageChanged description]翻页
             * @return {[type]} [description] null
             */
            $scope.pageChanged = function() {
                // $scope.status.params.CURRPAGE = $scope.page.CURRPAGE;
                $scope.params.CURRPAGE = $scope.page.CURRPAGE;
                $scope.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };
            /**
             * [jumpToPage description]到指定页
             * @return {[type]} [description] null
             */
            $scope.jumpToPage = function() {
                if ($scope.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.copyCurrPage = $scope.page.PAGECOUNT;
                }
                // $scope.status.params.CURRPAGE = $scope.copyCurrPage;
                $scope.params.CURRPAGE = $scope.copyCurrPage;
                $scope.page.CURRPAGE = $scope.copyCurrPage;
                requestData();
            };
            /**
             * [selectPageNum description]单页选择页数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function() {
                $scope.params.CURRPAGE = $scope.page.CURRPAGE = 1;
                $scope.params.PAGESIZE = $scope.page.PAGESIZE;
                $scope.copyCurrPage = 1;
                requestData();
            };

            function initStatus() {
                $scope.page = {
                    "CURRPAGE": 1,
                    "PAGESIZE": 20
                };
                $scope.params = {
                    "serviceid": "mlf_watermark",
                    "methodname": "queryWaterMarks",
                    "CurrPage": $scope.page.CURRPAGE,
                    "PageSize": $scope.page.PAGESIZE,
                    "LIBID": $stateParams.site
                };
                $scope.status = {

                };
                $scope.data = {
                    items: []
                };
                dropList();
            }




            /**
             * [selectStatus description]根据状态筛选水印
             * @params [{}] [description]
             * @return null [description]
             */

            $scope.selectStatus = function() {
                $scope.params.STATUS = $scope.status.selectStatus.value;
                requestData();
            };


            /**
             * [visualizeNew description]新建水印
             * @return {[type]} [description] null
             */
            $scope.createWatermark = function() {
                productManageMentService.createWatermark().then(function(data) {
                    requestData();
                });
            };




            /**
             * [deleteTemplate description]批量删除水印
             * @return {[type]} [description] null
             */
            $scope.deleteTemplate = function() {
                modalDialog.confirmModal("删除", "确定删除？", function() {
                    var params = {
                        serviceid: "mlf_watermark",
                        methodname: "deleteWaterMark",
                        LibId: $scope.params.LIBID,
                        ObjectIds: trsspliceString.spliceString($scope.data.selectedArray,
                            "WATERMARKID", ',')
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post")
                        .then(function(data) {
                            modalDialog.alertType("删除成功", "", "success", false);
                            requestData();
                        });
                });
            };

            //删除操作

            $scope.deleteViews = function(websiteItem) {
                modalDialog.confirmModal("删除", "确定删除？", function() {
                    var delParams = {
                        serviceid: "mlf_watermark",
                        methodname: "deleteWaterMark",
                        ObjectIds: websiteItem.WATERMARKID,
                        LibId: $scope.params.LIBID
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), delParams, "post")
                        .then(function(data) {
                            modalDialog.alertType("删除成功", "", "success", false);
                            requestData();
                        });
                });
            };
            /**
             * [enableDisable description]启用停用水印
             * @return null [description]
             */
            $scope.enableDisable = function(websiteItem) {
                if (websiteItem.STATUS == '0') {
                    modalDialog.confirmModal('提示信息', "确定停用？", function() {
                        $scope.disableSite(websiteItem, '-1');
                    });

                } else {
                    modalDialog.confirmModal('提示信息', "确定启用？", function() {
                        $scope.disableSite(websiteItem, '0');
                    });

                }
            };


            $scope.disableSite = function(websiteItem, type) {
                var checkParams = {
                    serviceid: "mlf_watermark",
                    methodname: "restoreWatermark",
                    ObjectId: websiteItem.WATERMARKID,
                    Status: type,
                    LibId: $scope.params.LIBID
                };
                var alertText = type == 0 ? "启用成功" : "停用成功";
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), checkParams, "post")
                    .then(function(data) {
                        modalDialog.alertType(alertText, "", "success", false);
                        requestData();
                    });
            };


            function initData() {
                getWatermarkRights();
                requestData();
            }

            function requestData() {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                    $scope.data.items = data.DATA;
                    $scope.page = data.PAGER ? data.PAGER : $scope.page;
                    $scope.data.selectedArray = [];
                });
            }

            function dropList() {
                //初始化水印类型
                $scope.status = {
                    statusOptions: [{
                        name: "全部状态",
                        value: "",
                    }, {
                        name: "启用",
                        value: 0,
                    }, {
                        name: "停用",
                        value: -1
                    }],
                };
                $scope.status.selectStatus = $scope.status.statusOptions[0];
            }
            /**
             * [handlePic description] 处理小图片
             * @param  {[type]} item [description] 处理项
             * @return {[type]}      [description]
             */
            $scope.handlePic = function(item) {
                if (item.PICSRC) {
                    item.ALLIMG = [{
                        PICSLOGO: item.PICSRC,
                    }];
                    item.METALOGOURL = { PICSLOGO: item.PICSRC, PICSLOGO2: item.PICSRC };
                }
            };
        }
    ]);